import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { RECONCILIATION_STEP } from 'features/accounting/debts/types';
import { type TAccountingState } from 'features/accounting/types';

const initialState: TAccountingState = {
  reconciliationStep: RECONCILIATION_STEP.IMPORT,
};

export const accountingSlice = createSlice({
  name: 'accounting',
  initialState,
  reducers: {
    setReconciliationStep(state, action: PayloadAction<RECONCILIATION_STEP>) {
      state.reconciliationStep = action.payload;
    },
    resetReconciliationStep(state) {
      state.reconciliationStep = RECONCILIATION_STEP.IMPORT;
    },
  },
});

export const { setReconciliationStep, resetReconciliationStep } =
  accountingSlice.actions;

export const accountingReducer = accountingSlice.reducer;
export default accountingSlice.reducer;
